import { EXCHANGE_ROUTES, EXCHANGE_ROUTES_MAP } from '../model/constants';

interface ExchangeSkipStepsOptions {
	skipPassengers: boolean;
}

export const getExchangePrevPath = (
	currentPath: string,
	{ skipPassengers }: ExchangeSkipStepsOptions
): string | null => {
	const prevPath = EXCHANGE_ROUTES_MAP.get(currentPath)?.prev ?? null;

	if (!prevPath) {
		return null;
	}

	if (prevPath === EXCHANGE_ROUTES.passengers && skipPassengers) {
		return null;
	}

	return prevPath;
};
